<script setup lang="ts">
import { type FunctionalComponent } from 'vue'
import { marked } from 'marked'

type MarkdownProps = {
  content?: string
  tag?: string
}

const props = defineProps<MarkdownProps>()

const MarkdownContent: FunctionalComponent = () => {
  if (!props.content) return null

  // Inline parse for a specific tag (e.g. h1) avoids invalid <h1><p>…</p></h1>;
  // the default <div> keeps block parsing.
  const html = props.tag ? marked.parseInline(props.content) : marked.parse(props.content)

  return h(props.tag || 'div', {
    class: 'markdown',
    innerHTML: html as string,
  })
}
</script>

<template>
  <MarkdownContent />
</template>

<style></style>
